import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { StockModelCardDealerInfoStyled } from '../StockModelCardDealerInfoStyled';
import { rem } from 'polished';

export const StockModelCardDealerInfoStyledAP = styled(StockModelCardDealerInfoStyled)`
    .dealer-location {
        margin-left: ${rem('25px')};
        margin-right: ${rem('25px')};
        &--info {
            font-size: ${rem('12px')};
        }
    }
`;
